import { PERSONAL_CATEGORIES_FILTER, PERSONAL_STORES_FILTER } from "./personal-filters";
import type { ProductFilters } from "./types";

export const MIN_PERSISTED_PERSONAL_FILTER_SIZE = 3;

export function hasBroadPersonalSelection(values: readonly string[] = []): boolean {
  return new Set(values.map((value) => value.trim()).filter(Boolean)).size >=
    MIN_PERSISTED_PERSONAL_FILTER_SIZE;
}

/** Active view state is temporary; saved preferences/notification choices are not. */
export function filtersForNewVisit(filters: ProductFilters): ProductFilters {
  return {
    ...filters,
    query: "",
    store: filters.store === PERSONAL_STORES_FILTER &&
      hasBroadPersonalSelection(filters.personalStores) ? PERSONAL_STORES_FILTER : "all",
    categoryId: filters.categoryId === PERSONAL_CATEGORIES_FILTER &&
      hasBroadPersonalSelection(filters.personalCategoryIds) ? PERSONAL_CATEGORIES_FILTER : "all",
    catalogId: "all",
    sort: "default",
  };
}

/** Hydrate cloud preferences once, before interaction. Later syncs must not
 * resurrect yesterday's filter, erase a live search or change a deep-link view.
 */
export function createVisitFilterHydration() {
  let pending = true;
  return {
    keepCurrent(): void { pending = false; },
    takeInitial(remote: ProductFilters): ProductFilters | null {
      if (!pending) return null;
      pending = false;
      return filtersForNewVisit(remote);
    },
  };
}
